import Client, { ClientOption } from "../client";

export default {
  // Get list of all question sets
  getQuestionSetList: (options?: ClientOption) =>
    Client("GET", `question-sets`, undefined, options),

  // Get question set by ID with pagination for top participants
  getQuestionSetById: (id: number, pageNo: number, options?: ClientOption) =>
    Client("GET", `question-sets/${id}?page=${pageNo}`, undefined, options),

  // Submit quiz answers for a question set
  submitQuestionSetQuiz: (params: any, options?: ClientOption) =>
    Client("POST", "question-sets/submit-quiz", params, options),
};
